import React from 'react';
import { Col, Row } from 'antd';

import { withAppContext } from 'contexts/AppContext/AppContext';

import Content from './Components/Content';

// import ClickableTextButton from 'components/ClickableTextButton/ClickableTextButton';
import Title from 'components/Font/Title/Title';

import { Root, MainContainer, TitleContainer } from './About.style';

const TermsAndCondition = () => {
  return (
    <Root>
      <Row>
        {/* Note: Remember to add to both mobile view and desktop view for any changes */}
        <Col span={0} sm={24}>
          <MainContainer>
            <TitleContainer>
              <Title>About Us</Title>
            </TitleContainer>
            <Content />
          </MainContainer>
        </Col>
        <Col span={24} sm={0}>
          <MainContainer>
            <TitleContainer>
              <Title>About Us</Title>
            </TitleContainer>
            <Content />
          </MainContainer>
        </Col>
      </Row>
    </Root>
  );
};

export default withAppContext(TermsAndCondition);
